module.exports = __webpack_public_path__ + "fonts/EUDC.ec720884.TTF";